<template>
    <div class="c-header">
        <van-nav-bar
                :title="pops.title"
                :left-text="pops.leftText"
                :right-text="pops.rightText"
                :left-arrow="pops.leftArrow"
                :border="pops.border"
                @click-left="onClickLeft"
                @click-right="onClickRight"
                fixed
        >
            <slot/>
            <template #left v-if="!pops.leftArrow">
                <slot name="left"/>
            </template>
            <template #title v-if="!pops.title">
                <slot name="title"/>
            </template>
            <template #right>
                <slot name="right"/>
            </template>
        </van-nav-bar>
    </div>
</template>

<script>
    import { ref,
        reactive,
        getCurrentInstance} from "vue";
    import router from "@/router";
    export default {
        props:{
            title:String,
            leftText:String,
            rightText:String,
            leftArrow:Boolean,
            border:Boolean
        },
        setup(props){
            const { ctx } = getCurrentInstance();
            const pops = reactive({
                ...props
            });
            const onClickLeft = () =>  {
                if(pops.leftArrow){
                    router.go(-1);
                }
            };
            const onClickRight = () => {

            };
            return { onClickLeft,onClickRight,pops }
        }
    }
</script>

<style lang="scss">
    .van-nav-bar{
        height:88px;
        line-height: 88px;
    }
    .van-nav-bar .van-icon{
        color:#333333;
    }
    .van-nav-bar__text{
        color:#333333;
    }
</style>
